var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUntick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 27C20.9558 27 27 20.9558 27 13.5C27 6.04415 20.9558 0 13.5 0C6.04415 0 0 6.04415 0 13.5C0 20.9558 6.04415 27 13.5 27Z",
    fill: "#121C2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5689 18.8822L6.40687 14.7276C5.83707 14.1588 5.86978 13.2589 6.47963 12.7275C7.08949 12.196 8.05435 12.2266 8.62415 12.7953L11.8345 15.9999L16.9161 11.5718C16.9618 11.5319 17.0096 11.4954 17.059 11.4618L19.4486 9.37944C20.0585 8.84801 21.0234 8.87859 21.5932 9.44738C22.163 10.0161 22.1302 10.9161 21.5204 11.4475L14.2217 17.8077L14.2139 17.7999L11.6892 20L10.5689 18.8822Z",
    fill: "#202B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUntick);
export default __webpack_public_path__ + "static/media/untick.b1c068c805f15f0c88104b54343b9dcd.svg";
export { ForwardRef as ReactComponent };